/**
 * Share API — mirrors `metsadata/backend/internal/handlers/smt_share_handler.go`.
 *
 *   POST   /api/v1/smt/shares              Create
 *   GET    /api/v1/smt/shares              ListOutgoing
 *   GET    /api/v1/smt/shares/incoming     ListIncoming
 *   DELETE /api/v1/smt/shares/:id          Revoke
 */
import { request, requestData } from './client.ts';

export interface Share {
  id: number;
  estate_id: number;
  recipient_email: string;
  recipient_user_id?: number | null;
  shared_by: number;
  message?: string | null;
  created_at: string;
  accepted_at?: string | null;
  revoked_at?: string | null;
  revoked_by?: number | null;
  // Denormalised joins (populated by the backend's *WithDetails reads).
  estate_name?: string | null;
  estate_region?: string | null;
  municipality?: string | null;
  sharer_name?: string | null;
  sharer_email?: string | null;
  recipient_name?: string | null;
}

export interface CreateShareInput {
  estate_id: number;
  recipient_email: string;
  message?: string;
}

export async function createShare(input: CreateShareInput): Promise<Share> {
  return requestData<Share>('/smt/shares', { method: 'POST', body: input });
}

export async function listOutgoing(includeRevoked = false): Promise<Share[]> {
  const data = await requestData<Share[] | null>('/smt/shares', {
    query: { include_revoked: includeRevoked ? 'true' : undefined },
  });
  return data ?? [];
}

export async function listIncoming(): Promise<Share[]> {
  const data = await requestData<Share[] | null>('/smt/shares/incoming');
  return data ?? [];
}

export async function revokeShare(id: number): Promise<void> {
  await request<unknown>(`/smt/shares/${id}`, { method: 'DELETE' });
}
